module.exports = __webpack_public_path__ + "static/media/2.56af9a05.svg";